document.addEventListener("DOMContentLoaded", function () {
  
  const displayPrices = function () {
    //variant questions get price ranges
    //selling plan questions get prices once variant is selected
  };

  const getSellingPlanId = function (quizData, quizObject) {
    const variantId = quizData.variant_id.value;
    const prepaidOption =
      quizData.selling_plan_id.value.toString() === "yes"
        ? "prepaid"
        : "recurring";
    const bundleVariant = quizObject.bundleProductVariants.filter(
      (variant) => variant.id.toString() === variantId.toString()
    );
    const sellingPlan = bundleVariant[0].selling_plans.filter(
      (sellingPlan) => sellingPlan.type === prepaidOption
    );
    return sellingPlan[0].id;
  };

  const quizAnswerHandler = function (event) {
    const selectedAnswer = event.currentTarget;
    const quizWrapper = selectedAnswer.closest(".quiz-wrapper");
    const errorMessage = quizWrapper.querySelector(".quiz-question__error");
    errorMessage.textContent = "";
    const quizId = quizWrapper.getAttribute("data-quiz-id");
    const answerValue = selectedAnswer.querySelector("input, button").value;
    // Deselect all answers in the same question
    const question = selectedAnswer.closest(".quiz-question");
    const allAnswers = question.querySelectorAll(
      ".quiz-question__answers .quiz-question__answer input, .quiz-question__answers .quiz-question__answer button"
    );
    allAnswers.forEach(function (answer) {
      if (answer.tagName.toLowerCase() === "button") {
        answer.classList.remove("button--primary");
        answer.classList.add("button--secondary");
      }
    });
    if (selectedAnswer.querySelector("button")) {
      selectedAnswer.querySelector("button").classList.add("button--primary");
      selectedAnswer
        .querySelector("button")
        .classList.remove("button--secondary");
    }
    const dataType =
      selectedAnswer.querySelector("input, button").getAttribute("data-type") ||
      "default";
    const dataKey =
      selectedAnswer.querySelector("input, button").getAttribute("data-key") ||
      "default";
    const targetElement = selectedAnswer.querySelector("input, button");
    saveQuizData(quizId, dataType, dataKey, answerValue, targetElement);
    transitionFrames();
    setConditionalDisplay(quizId);
  };

  const setConditionalDisplay = function (quizId) {
    const questions = document.querySelectorAll(".quiz-frame.active .quiz-question");
    questions.forEach((question) => {
      //if data-condition is set, check if it is met and only show it if so
      const condition = question.getAttribute("data-condition");
      if (condition) {
        let conditionArray = condition.split(":");
        const quizData = getQuizData(quizId);
        if (quizData && quizData[conditionArray[0]] && quizData[conditionArray[0]].value.toString() === conditionArray[1].toString()) {
          question.classList.add('conditional-displayed')
        }
      }
      else {
        question.classList.add('conditional-displayed');
      }
    });
  }

  const transitionFrames = function () {
    const quizWrapper = document.querySelector(".quiz-wrapper");
    const quizId = quizWrapper.getAttribute("data-quiz-id");
    const frames = quizWrapper.querySelectorAll(".quiz-frame");
    const activeFrame = quizWrapper.querySelector(".quiz-frame.active");
    let activeFrameIndex = -1;

    //only transition if all questions are answered in the active frame
    if (frames.length === 0) {
      return;
    }
    
    //if active frame contains the class "quiz-frame--no-transition", skip transition
    if (activeFrame.classList.contains("quiz-frame--no-transition")) {
      return;
    }

    // Check if all questions in the active frame are answered
    const allQuestionsAnswered = Array.from(activeFrame.querySelectorAll(".quiz-question.conditional-displayed")).every(
      (question) => {
        const answers = question.querySelectorAll(
          ".quiz-question__answers .quiz-question__answer input, .quiz-question__answers .quiz-question__answer button"
        );
        return Array.from(answers).some((answer) => {
          return (
            answer.checked ||
            (answer.tagName.toLowerCase() === "button" &&
              answer.classList.contains("button--primary"))
          );
        });
      }
    );

    if (!allQuestionsAnswered) {
      return;
    }

    // Find the currently active frame
    frames.forEach((frame, index) => {
      if (frame.classList.contains("active")) {
        activeFrameIndex = index;
        frame.classList.remove("active");
      }
    });

    // Activate the next frame, if available
    if (activeFrameIndex + 1 < frames.length) {
      frames[activeFrameIndex + 1].classList.add("active");
    } else {
      return;
    }
  }

  const saveQuizData = function (quizId, dataType, dataKey, answerValue, element) {
    let elementName = element ? element.localName : null;
    let storedData = getQuizData(quizId) || {};
    const dataKey_lower = dataKey.toLowerCase() || "default";
    let saveValue = answerValue
    if (elementName === 'input') {
      //if input not checked, remove it from saved data
      if (!element.checked) {
        saveValue = [];
      }

      if (!storedData[dataKey_lower] || !Array.isArray(storedData[dataKey_lower].value)) {
        saveValue = [];
        saveValue.push(answerValue);
      }
      else {
        saveValue = storedData[dataKey_lower].value || [];
        if (!element.checked) {
          let index = saveValue.indexOf(answerValue);
          if (index > -1) {
            saveValue.splice(index, 1);
          }
        }
        else {
          saveValue.push(answerValue);
        }
      }
      saveValue = [...new Set(saveValue)];
    }
    storedData[dataKey_lower] = {
      type: dataType,
      key: dataKey_lower,
      value: saveValue,
    };
    if (dataType === "filter") {
      storedData[dataKey_lower].filterName = dataKey;
    }
    localStorage.setItem("tokidosQuiz_" + quizId, JSON.stringify(storedData));
  };

  const getQuizData = function (quizId) {
    const savedData = localStorage.getItem("tokidosQuiz_" + quizId);
    return savedData ? JSON.parse(savedData) : null;
  };

  const filterProducts = function (quizObject, quizId) {
    const quizData = getQuizData(quizId);

    if (!quizData) {
      return;
    }

    //get filters from quizData
    const filters = Object.values(quizData).reduce((acc, item) => {
      if (item.type === "filter") {
        let this_key = item.key;
        if (this_key === 'âge') {
          this_key = 'age'
        }
        acc[this_key] = item.value;
      }
      return acc;
    }, {});

  // Apply filters to products
    const filteredProducts = quizObject.products.filter((product) => {
      return Object.keys(filters).every((filterKey) => {
        const filterValue = filters[filterKey];
        return product[filterKey] && product[filterKey].includes(filterValue);
      });
    });
    
    // Get random 3 products from filtered products
    const randomProducts = filteredProducts
      .sort(() => 0.5 - Math.random())
      .slice(0, 3);

    // return variant ids of random products
    let variantIds = randomProducts.map((product) => product.variants[0]);

    //console.log('variant ids if not rect', variantIds);

    //check if this quiz is on a product
    if (quizData.context && quizData.context.value === 'product' && quizObject.isProductPage === 'true') {

      //console.log('should run product recs')
      //console.log(filters)
      let age_groups = {
        '3_4': 0,
        '5_6': 0,
        '7_8': 0
      };

      if (filters['age']) {
        for (let i = 0; i < filters['age'].length; i++) {
          if (filters['age'][i] === '3' || filters['age'][i] === '4') {
            age_groups['3_4']++;
          }
          else if (filters['age'][i] === '5' || filters['age'][i] === '6') {
            age_groups['5_6']++;
          }
          else if (filters['age'][i] === '7' || filters['age'][i] === '8') {
            age_groups['7_8']++;
          }
        }
      }

      //remove empty age groups
      for (const key in age_groups) {
        if (age_groups[key] === 0) {
          delete age_groups[key];
        }
      }

      //console.log(age_groups)

      let age_selections = []
      if (Object.keys(age_groups).length === 3) {
        age_selections.push({'3_4': 1});
        age_selections.push({'5_6': 1});
        age_selections.push({'7_8': 1});
      }
      else if (Object.keys(age_groups).length === 2) {
        //first an item for each group
        for (const key in age_groups) {
          age_selections.push({[key]: age_groups[key]});
        }
        //sort age selections by key
        age_selections.sort((a, b) => {
          const keyA = Object.keys(a)[0];
          const keyB = Object.keys(b)[0];
          return keyA.localeCompare(keyB);
        });
        //if the total number of selections is less than 3, add more
        const totalSelections = age_selections.reduce((acc, item) => acc + Object.values(item)[0], 0);
        //console.log('total selections', totalSelections);
        if (totalSelections < 3) {
          //console.log('case of < 3')
          age_selections[0] = { [Object.keys(age_groups)[0]]: 2 };
          age_selections[1] = { [Object.keys(age_groups)[1]]: 1 };
        }
        else if (totalSelections > 3) {
          //console.log('case of > 3')
          age_selections[1] = { [Object.keys(age_groups)[1]]: 1 };
        }
        //merge age selections and increment count
        const mergedSelections = age_selections.reduce((acc, item) => {
          const key = Object.keys(item)[0];
          acc[key] = (acc[key] || 0) + Object.values(item)[0];
          return acc;
        }, {});
        age_selections = Object.entries(mergedSelections).map(([key, value]) => ({ [key]: value }));
      }
      else if (Object.keys(age_groups).length === 1) {
        age_selections.push({[Object.keys(age_groups)[0]]: 3});
      }

      if (
        (quizData.language && quizData.language.value && quizData.language.value === 'French') ||
        (quizData.langue && quizData.langue.value && quizData.langue.value === 'Français')
      )
      {
        age_selections.forEach((selection) => {
          const ageGroup = Object.keys(selection)[0];
          const count = Object.values(selection)[0];
          for (let i = 0; i < count; i++) {
            let key = `age_${ageGroup}_fr`;
            variantIds.push(quizObject[key][i]);
          }
        });
      }
      else if (quizData.language && quizData.language.value && quizData.language.value === 'English') {
        age_selections.forEach((selection) => {
          const ageGroup = Object.keys(selection)[0];
          const count = Object.values(selection)[0];
          for (let i = 0; i < count; i++) {
            let key = `age_${ageGroup}_eng`;
            variantIds.push(quizObject[key][i]);
          }
        });
      }
      //console.log('age selections', age_selections);
      //console.log(variantIds)

    }
    
    return variantIds;
  };

  let quizes = document.querySelectorAll(".section-tokidos-quiz .quiz-wrapper");
  if (quizes.length === 0) {
    return;
  }

  // Initialize each quiz
  quizes.forEach(function (quiz) {

    // Initialize each quiz
    const quizId = quiz.getAttribute("data-quiz-id");
    localStorage.removeItem("tokidosQuiz_" + quizId);

    const quizObjectName = "tokidosQuiz_" + quizId;
    if (!window[quizObjectName]) {
      return;
    }
    const quizObject = window[quizObjectName];

    let questions = quiz.querySelectorAll(".quiz-question");
    questions.forEach(function (question) {
      // Initialize each question and answer
      const quizAnswers = question.querySelectorAll(
        ".quiz-question__answers .quiz-question__answer"
      );
      quizAnswers.forEach(function (answer) {

        // Initialize each answer
        const answerValue = answer.querySelector("input, button").value;
        answer.addEventListener("click", function () {
          // Handle answer selection
          quizAnswerHandler(event);
        });

        //bind labels to toggle inputs
        const label = answer.querySelector("label");
        if (label) {
          label.addEventListener("click", function (event) {
            if (event.target.localName === "label") {
              const input = answer.querySelector("input");
              if (input) {
                input.click();
              }
            }
          });
        }

      });
    });

    displayPrices();
    setConditionalDisplay(quizId);

    //if quiz has a product page context, inject a button to open the quiz
    if (quizObject.isProductPage === "true") {

      const button = document.createElement("button");
      button.className = "button button--primary";
      button.textContent = quizObject.buttonText || "Customize your bundle";
      button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        const inputs = quiz.querySelectorAll(".quiz-question__answer input");
        inputs.forEach((input) => {
          if (input.checked) {
            input.checked = false;
          }
        });
        
        //set selected variant and selling plan values
        const selectedVariant = document.querySelector('input.product-variant-id');
        const selectedSellingPlan = document.querySelector('.bundleapp-plan-selector-group--selected .bundleapp-plan-selector-radio__input');
        if (selectedVariant) {
          const variantId = selectedVariant.value;
          saveQuizData(quizId, "variant_id", "variant_id", variantId);
          const includesPlaycubes = quizObject.bundleProductVariants.find(variant => variant.id.toString() === selectedVariant.value.toString())?.includesPlaycubes;
          saveQuizData(quizId, "includes_playcubes", "includes_playcubes", includesPlaycubes);
          if (includesPlaycubes) {
            const playcubeVariantId = quizObject.playcubeVariantId;
            saveQuizData(quizId, "playcube_variant_id", "playcube_variant_id", playcubeVariantId);
          }
        }
        if (selectedSellingPlan) {
          const sellingPlanId = selectedSellingPlan.value;
          saveQuizData(quizId, "selling_plan_id", "selling_plan_id", sellingPlanId);
        }

        //if the quiz has now questions, it is only to set hidden settings, so no need to display it
        console.log('inputs length', inputs.length);
        if (inputs.length === 0) {
          //redirect to bundle url with hidden settings
          const quizId = quiz.getAttribute("data-quiz-id");
          const quizData = getQuizData(quizId);
          let bundleUrl = "/tools/bundle-subscriptions/bundle/";
          if (
            (quizData.language && quizData.language.value && quizData.language.value === 'French') ||
            (quizData.langue && quizData.langue.value && quizData.langue.value === 'Français')
          ) {
            bundleUrl = "/fr/tools/bundle-subscriptions/bundle/";
          }
          bundleUrl += quizObject.bundleId + "?";
          bundleUrl = buildUrlParams(quizData, bundleUrl);
          bundleUrl += `&quiz=${quizId}`;
          window.location.href = bundleUrl;
        }
        else {
          // Show the quiz when the button is clicked
          quiz.closest(".section-tokidos-quiz").classList.add("displayed");
        }

      });
      const buttonContainer = document.querySelector(".product-form__buttons");
      if (buttonContainer) {
        buttonContainer.appendChild(button);
      }
    }



    const submitButton = quiz.querySelector(".quiz-submit-button");
    if (submitButton) {
      submitButton.addEventListener("click", function () {
        // check that all questions have an answer
        const allQuestionsAnswered = Array.from(questions).every((question) => {
          let isAnswered = false;
          const selectedAnswers = question.querySelectorAll(".quiz-question__answer");
          selectedAnswers.forEach((answer) => {
            if (answer.querySelector('button') && answer.querySelector('button').classList.contains('button--primary')) {
              isAnswered = true;
            }
            if (answer.querySelector('input[type="checkbox"]:checked') !== null) {
              isAnswered = true;
            }
          });
          return isAnswered;
        });

        if (!allQuestionsAnswered) {
          const errorMessage = quiz.querySelector(".quiz-question__error");
          errorMessage.textContent = "Please answer all questions before submitting.";
          return;
        }

        // Handle quiz submission
        const quizId = quiz.getAttribute("data-quiz-id");
        const quizData = getQuizData(quizId);
        
        let variantIds = filterProducts(quizObject, quizId);
        //console.log('variantIds:', variantIds);
        let selectedVariantsString = variantIds.join("=1&") + "=1";
        let bundleUrl = "/tools/bundle-subscriptions/bundle/";
        if (
        (quizData.language && quizData.language.value && quizData.language.value === 'French') ||
        (quizData.langue && quizData.langue.value && quizData.langue.value === 'Français')
        ) {
          bundleUrl = "/fr/tools/bundle-subscriptions/bundle/";
        }
        bundleUrl += quizObject.bundleId + "?";
        bundleUrl = buildUrlParams(quizData, bundleUrl);
        if (selectedVariantsString) {
          bundleUrl += selectedVariantsString;
        }
        bundleUrl += `&quiz=${quizId}`;
        window.location.href = bundleUrl;
        //console.log('bundleUrl',bundleUrl)
      });
    }

    const buildUrlParams = function (quizData, bundleUrl) {
      for (const key in quizData) {
        if (quizData.hasOwnProperty(key)) {
          const item = quizData[key];
          if (item.type === "filter") {
            //if item.value is array, build params for each array value
            if (Array.isArray(item.value)) {
              item.value.forEach(function (value) {
                bundleUrl += `${item.filterName}=${value}&`;
              });
            } else {
              bundleUrl += `${item.filterName}=${item.value}&`;
            }
          } else if (item.type === "variant_id") {
            const variant_id = item.value;
            if (variant_id) {
              bundleUrl += `variant=${variant_id}&`;
            }
          } else if (item.type === "selling_plan_id") {
            //const selling_plan = getSellingPlanId(quizData, quizObject);
            const selling_plan = item.value;
            //get selling plan from quizObject
            if (selling_plan) {
              bundleUrl += `selling_plan=${selling_plan}&`;
            }
          }
        }
      }
      return bundleUrl;
    };

    //get context
    if (window.location.pathname.includes("/products")) {
      saveQuizData(quizId, "context", "context", 'product');
    }

    saveQuizData(quizId, "text", "bundle_builder_message", quizObject.bundleMessage);
    saveQuizData(quizId, "text", "playcubes_message", quizObject.playCubesMessage);
    saveQuizData(quizId, "text", "playcubes_message_property", quizObject.playCubesProp);

    const hiddenSettings = quiz.querySelectorAll(".quiz-hidden-settings");
    hiddenSettings.forEach(function (setting) {
      const dataType = setting.getAttribute("data-type") || "default";
      const dataKey = setting.name;
      const answerValue = setting.value;
      const quizId = quiz.getAttribute("data-quiz-id");
      // Save hidden settings data
      saveQuizData(quizId, dataType, dataKey, answerValue);
    });

    //if quiz has a button selector, add click event to it
    const buttonSelector = quizObject.buttonSelector;
    if (buttonSelector !== "") {
      const button = document.querySelector(buttonSelector);
      if (button) {
        button.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          // Show the quiz when the button is clicked
          quiz.closest(".section-tokidos-quiz").classList.add("displayed");
        });
      }

      //bind escape key to close the quiz
      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
          quiz.closest(".section-tokidos-quiz").classList.remove("displayed");
        }
      });
      // Add a click event to close the quiz when clicking outside of it
      document.addEventListener("click", function (event) {
        if (
          !quiz.contains(event.target) &&
          !button.contains(event.target) &&
          quiz.closest(".section-tokidos-quiz").classList.contains("displayed")
        ) {
          quiz.closest(".section-tokidos-quiz").classList.remove("displayed");
        }
      });

    } else {
      // If no button selector is provided, automatically display the quiz inline
      //quiz.closest(".section-tokidos-quiz").classList.add("displayed");
    }
  });
});
